import { Options, Vue } from "vue-class-component";
import { customField, CustomField, CustomFieldValue } from "./type";

@Options({
  props: ["modelValue", "viewOnly"],
  emits: ["update:modelValue"],
})
export default class CustomFieldComponent extends Vue {
  modelValue: CustomField;
  viewOnly: boolean;

  created(): void {
    console.log("this.modelValue", this.modelValue)
  }

  addRow(e: any) {
    e.preventDefault();
    if (!this.modelValue.value) {
      this.modelValue.value = [];
    }

    const value: CustomFieldValue = {
      label: "",
      value: "",
      table: false,
    };
    this.modelValue.value.push(value);
  }

  removeRow(index, e: any) {
    e.preventDefault();
    this.modelValue.value.splice(index, 1);
  }
}
